"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowLeftIcon = void 0;
const react_1 = __importDefault(require("react"));
const ArrowLeftIcon = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement("svg", { width: "15", height: "12", viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M1 5.5H14M14 5.5L9.5 1M14 5.5L9.5 10", stroke: props === null || props === void 0 ? void 0 : props.stroke, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.ArrowLeftIcon = ArrowLeftIcon;
